import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'nz-pagination-net',
  preserveWhitespaces: false,
  templateUrl: './nz-pagination-net.component.html',
  styles: [`
    .pagination_wrap {
      width: 100%;
      min-height: 3em;
      flex-wrap: wrap;
      font-size: 12px;
      font-family: 'MicrosoftYaHei';
      color: #0B1100;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
    }

    .pagination_left {
      min-width: 21em;
      display: inline-flex;
      align-items: center;
      justify-content: space-around;
    }

    .pagination_select {
      display: inline;
    }

    .dropdownBtn {
      width: 60px;
      background-color: transparent;
      font-size: 12px;
      padding: 0;
    }

    .pagination_left span:not(:last-child) {
      margin-right: 1em;
    }

    .pagination_left span:last-child {
      margin-left: 1em;
    }

    .pagination_right {
      min-width: 26em;
      display: inline-flex;
      align-items: center;
    }

    .pagination_right a {
      color: #00313A;
      cursor: pointer;
      text-decoration: underline;
    }

    .pagination_right span {
      margin: auto 1em;
    }

    .pagination_input {
      width: 50px;
    }

    :host ::ng-deep .pagination_btn {
      background-color: #666666;
      border-radius: 3px;
      height: 30px;
      width: 50px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      border: none ;
      box-shadow: none ;
      outline: 0 ;
    }

    .pagination_input,
    :host ::ng-deep .ant-input-number-input-wrap {
      background-color: transparent;
    }

    :host ::ng-deep .ant-input-number-handler-wrap{
      display: none;
    }
  `]
})
export class NzPaginationNetComponent implements OnInit {

  @Input('pageLimit') pageLimit: number; // æ¯é¡µè¡æ°
  @Input('pageIndex') pageIndex: number; // å½åé¡µ
  @Input('pageTotal') pageTotal: number; // æ»æ¡æ°
  @Input('toPage') toPage: number = 1; // è¦è·³è½¬çé¡µ
  @Input('btnColor') btnColor: string = '#333333'; // æé®é¢è²

  @Output('limitChange') limitChange: EventEmitter<any> = new EventEmitter(); // limitåçåå
  @Output('indexChange') indexChange: EventEmitter<any> = new EventEmitter(); // indexåçåå

  public selectTypeCount: number = 5; // éé¡¹ç§ç±»æ°
  public selectCountBase: number = 10;  // éé¡¹åºæ°
  public totalPageCount: number = Math.ceil(this.pageTotal / this.pageLimit); // æ»é¡µæ°
  public selectCountData: any[]; // éé¡¹æ°æ®
  constructor() {
  }

  setSelectCountData(): void {
    let selectCount = [];
    for (let i = 0, j; i < this.selectTypeCount; i++) {
      j = (i + 1) * this.selectCountBase;
      selectCount.push({ value: j, label: j });
    }
    this.selectCountData = selectCount;
  }

  prevPage(): void  {
    if (this.pageIndex > 1) {
      this.pageIndex--;
      this.indexChange.emit(this.pageIndex);
    }
  }

  nextPage(): void  {
    this.getTotalPage();
    if (this.pageIndex < this.totalPageCount) {
      this.pageIndex++;
      this.indexChange.emit(this.pageIndex);
    }
  }

  onSelect($event: any): void  {
    this.pageLimit = $event;
    this.getTotalPage();
    this.pageIndex = 1;
    this.limitChange.emit($event);
  }

  goToPage(): void  {
    this.pageIndex = this.toPage;
    this.indexChange.emit(this.pageIndex);
  }

  getTotalPage(): number {
    this.totalPageCount = Math.ceil(this.pageTotal / this.pageLimit);
    return this.totalPageCount;
  }

  ngOnInit(): void {
    this.getTotalPage();
    this.setSelectCountData();
  }
}
